import { useEffect } from 'react';

import { SigningInSpinner } from '~src/app/spaces/Login/SigningInSpinner';
import { ExternalAuthService } from '~src/authentication/services/ExternalAuthService';
import { IGetSiteSamlLoginInfoResult } from '~src/ts/ServerApi/types/IGetSiteSamlLoginInfoResult';

import { RootLoginUiProps } from './RootLoginUi';
import React = require('react');


export interface ExternalIdPLoginProps extends RootLoginUiProps {
    siteSamlInfo?: IGetSiteSamlLoginInfoResult;
}

export function ExternalIdPLogin(props: ExternalIdPLoginProps) {
    useEffect(
      () => {
        // Redirect to kickoff the SAML/OpenId/Site-Saml login flow.
        ExternalAuthService.login(props.signinQueryParams, props.siteSamlInfo);
      },
      // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    return <SigningInSpinner />;
}
